import IconButton from '@mui/joy/IconButton'
import Visibility from '@mui/icons-material/Visibility'

export const PreviewButton = ({ onClick }) => (
    <IconButton variant="outlined" color="primary" onClick={onClick}>
        <Visibility />
    </IconButton>
)
